import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';
import { useTranslation } from '../hooks/useTranslation';

const Allergens = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header cartItemCount={0} onCartClick={() => {}} onOrderClick={() => {}} />
      
      <div className="pt-32 pb-20 px-4">
        <div className="max-w-4xl mx-auto">
          <Button
            onClick={() => navigate('/home')}
            variant="ghost"
            className="mb-8 hover:bg-gray-100"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('backToHome')}
          </Button>

          <h1 className="text-5xl font-bold text-black mb-8">{t('allergensTitle')}</h1>

          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-3xl font-bold text-black mb-4">{t('allergenListTitle')}</h2>
              <p className="mb-6">{t('allergenIntro')}</p>
              
              <div className="grid gap-3">
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">1.</span>
                  <span>{t('allergen1')}</span>
                </div>
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">2.</span>
                  <span>{t('allergen2')}</span>
                </div>
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">3.</span>
                  <span>{t('allergen3')}</span>
                </div>
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">4.</span>
                  <span>{t('allergen4')}</span>
                </div>
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">5.</span>
                  <span>{t('allergen5')}</span>
                </div>
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">6.</span>
                  <span>{t('allergen6')}</span>
                </div>
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">7.</span>
                  <span>{t('allergen7')}</span>
                </div>
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">8.</span>
                  <span>{t('allergen8')}</span>
                </div>
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">9.</span>
                  <span>{t('allergen9')}</span>
                </div>
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">10.</span>
                  <span>{t('allergen10')}</span>
                </div>
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">11.</span>
                  <span>{t('allergen11')}</span>
                </div>
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">12.</span>
                  <span>{t('allergen12')}</span>
                </div>
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">13.</span>
                  <span>{t('allergen13')}</span>
                </div>
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <span className="font-bold text-black mr-3 min-w-[30px]">14.</span>
                  <span>{t('allergen14')}</span>
                </div>
              </div>
            </section>

            <section className="pt-6 border-t-2 border-gray-200">
              <p className="text-sm text-gray-600">{t('allergenNote')}</p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Allergens;
